import { swSettings } from "app/common/services/swSettings";
import { FiltersEnum } from "app/components/filters-bar/utils";
import type { IFilterHandlerReturnObj, IParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import { DurationService } from "app/services/DurationService";

// Handle edge case where the user choose customDuration that is below the minimum allowed duration range
const isBelowMinimumDurationRange = (targetState: IRouterState, duration: string) => {
    const durationService = new DurationService();
    const monthsDiff = durationService.getMonthsFromDuration(duration);
    return targetState.minDurationRange! > monthsDiff;
};

export const getDurationRequiredChanges = (
    componentConfigId: string | null,
    selectedDuration: string,
    targetState: IRouterState,
    toParams: IParams,
): IFilterHandlerReturnObj => {
    const isAllowed =
        swSettings.allowedDuration(selectedDuration, componentConfigId, targetState) &&
        !isBelowMinimumDurationRange(targetState, selectedDuration);
    const isFilterDisabled = targetState.data?.filtersConfig?.duration === FiltersEnum.DISABLED;
    const displayChangeIndicator =
        (!isAllowed || (isFilterDisabled && selectedDuration !== toParams.duration)) && !toParams.isDurationChanged;
    const isChanged = !isAllowed || (isFilterDisabled && selectedDuration !== toParams.duration);
    const shouldChangeToSelected = selectedDuration !== toParams.duration && isAllowed && !isFilterDisabled;
    return {
        isAllowed,
        displayChangeIndicator,
        isChanged,
        shouldChangeToSelected,
    };
};
